/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupslistedhint2Inputs */

const en_groupslistedhint2 = /** @type {(inputs: Groupslistedhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone can join from your page in the app. Otherwise only by link.`)
};

const de_groupslistedhint2 = /** @type {(inputs: Groupslistedhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle können von deiner Seite in der App beitreten. Sonst nur über den Link.`)
};

/**
* | output |
* | --- |
* | "Anyone can join from your page in the app. Otherwise only by link." |
*
* @param {Groupslistedhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupslistedhint2 = /** @type {((inputs?: Groupslistedhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupslistedhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupslistedhint2(inputs)
	return de_groupslistedhint2(inputs)
});
export { groupslistedhint2 as "groupsListedHint" }